import React from 'react'
import FeaturedSection from '../sections/FeaturedSection'

function FrontPage() {
    return (
        <div>
            <FeaturedSection />
        </div>
    )
}

export default FrontPage